import {Footer} from '@common/ui/footer/footer';

import React, {Fragment, useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {MainNavbar} from '@app/main-navbar';
import {useDarkThemeVariables} from '@ui/themes/use-dark-theme-variables';
import {checkoutStatus} from '@app/checkout/checkout-content';
import {Trans} from '@ui/i18n/trans';

export function CheckoutSuccess() {
  const {slugOrId} = useParams();
  const darkThemeVars = useDarkThemeVariables();
  const [checkStatus, setCheckStatus] = useState<{status: string} | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slugOrId) return;
    let interval: NodeJS.Timeout | undefined;

    const fetchStatus = async () => {
      try {
        const status = await checkoutStatus(slugOrId);
        setCheckStatus(status);

        // Si le paiement est complété, on arrête la vérification automatique
        if (status?.status === 'completed') {
          clearInterval(interval);
        }
      } catch (error) {
        console.error('Error fetching checkout status:', error);
      } finally {
        setLoading(false);
      }
    };

    // Premier appel immédiat
    fetchStatus();

    // Lancer l'intervalle pour vérifier toutes les 5 secondes
    interval = setInterval(fetchStatus, 5000);

    // Nettoyage de l'intervalle si le composant est démonté
    return () => clearInterval(interval);
  }, [slugOrId]);

  if (!slugOrId) {
    return null;
  }

  return (
    <Fragment>
      <MainNavbar />
      <div style={darkThemeVars} className="dark min-h-screen bg text">
        <div className="container mx-auto p-14 md:p-24">
          <div className=" bottom-0 z-20 h-[6vw] w-full transform bg">
            <div className="mx-auto my-40 max-w-850 rounded border border-dashed px-20 py-30 text-center">
              <div className="mb-8 text-sm font-semibold text-warning">
                {loading ? (
                  <Trans message={'Checking your order status...'} />
                ) : checkStatus?.status === 'completed' ? (
                  <Trans message={'Thank you! Your order is complete.'} />
                ) : (
                  <Trans
                    message={'Your order is pending, please wait 2/3 minutes.'}
                  />
                )}
              </div>
              <div className="text-base text-muted"></div>
            </div>
          </div>
          <Footer className="mt-48" />
        </div>
      </div>
    </Fragment>
  );
}
